import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightbulb01 = function Lightbulb01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 16.5V19c0 .9319 0 1.3978-.1522 1.7654-.203.49-.5924.8794-1.0824 1.0824C13.3978 22 12.9319 22 12 22s-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C9 20.3978 9 19.9319 9 19v-2.5m6 0c2.6489-1.1573 4.5-3.9245 4.5-7C19.5 5.3579 16.1421 2 12 2S4.5 5.3579 4.5 9.5c0 3.0755 1.8511 5.8427 4.5 7m6 0H9"
    })
  }));
};
export default Lightbulb01;